const OFFER_PATHS = /^\/(oferta-e-sua|descubra-sua-oferta)(\/|$)/

export const isOfferPath = (path = '') => OFFER_PATHS.test(path)

// A Oferta é Sua fica disponível quando alguma filial tem opt-in de Desconto ou
// Cashback. Lista vazia ou ainda não carregada libera, igual ao fallback do menu.
export const hasOfferOptIn = (stores) => {
  if (!Array.isArray(stores) || !stores.length) return true

  return stores.some(
    (store) =>
      store.OptIns &&
      (store.OptIns.includes(process.env.REACT_APP_OPTIN_DESCONTO) ||
        store.OptIns.includes(process.env.REACT_APP_OPTIN_CASHBACK))
  )
}
